import { type FC } from "react";
import { Route, Routes } from "react-router-dom";
import { ExistedCustomer } from "components/ExistedCustomer/ExistedCustomer";

export const ExistedCustomerRoutes: FC = () => (
  <Routes>
    <Route index element={<ExistedCustomer />} />
  </Routes>
);
